import React, {useEffect} from 'react'
import {useFormContext, useFormState} from 'react-hook-form'
import {ErrorMessage} from '@hookform/error-message'
//import Help from 'form/Help'
import {get, cn, noop} from 'utils'

const renderOptions = (options: any) => options.map(({label, value, options, disabled}: any) => {
	return options ? (
		<optgroup key={`group_${label}`} label={label} disabled={disabled}>{renderOptions(options)}</optgroup>
	) : (
		<option key={value} value={value}>{label}</option>
	)
})

export default function SimpleSelect({
	id,
	name,
	label,
	placeholder,
	rules,
	help,
	observe = noop,
	options=[],
	className,
	outerClassName,
	...props
}: any) {

	const {register, watch} = useFormContext()
	const {errors} = useFormState()
	const watched = watch(name, '')

	useEffect(() => observe(watched), [observe, watched])
	return (
		<div className={cn('form-floating', outerClassName)}>
		  <select
		  	{...register(name, rules)}
		  	className={cn('form-select', className, {'is-invalid': get(errors, name)})}
		  	id={id}
		  	aria-label={label}
		  	defaultValue=""
		  >
		    {placeholder && (
		    	<option disabled value="">{placeholder}</option>
		    )}
		    {renderOptions(options)}
		  </select>
		  <label htmlFor={name}>{label}</label>
			<ErrorMessage
				name={name}
				errors={errors}
				render={({ message }) => (
					<div className="invalid-feedback d-block">{message}</div>
				)}
			/>
		</div>
	)
}

const COUNTRIES_ALL = [
    {
        "value": "AF",
        "label": "Afghanistan"
    },
    {
        "value": "EG",
        "label": "Egypt"
    },
    {
        "value": "AL",
        "label": "Albania"
    },
    {
        "value": "DZ",
        "label": "Algeria"
    },
    {
        "value": "AD",
        "label": "Andorra"
    },
    {
        "value": "AO",
        "label": "Angola"
    },
    {
        "value": "AG",
        "label": "Antigua & Barbuda"
    },
    {
        "value": "GQ",
        "label": "Equatorial Guinea"
    },
    {
        "value": "AR",
        "label": "Argentina"
    },
    {
        "value": "AM",
        "label": "Armenia"
    },
    {
        "value": "AZ",
        "label": "Azerbaijan"
    },
    {
        "value": "ET",
        "label": "Ethiopia"
    },
    {
        "value": "AU",
        "label": "Australia"
    },
    {
        "value": "BS",
        "label": "Bahamas"
    },
    {
        "value": "BH",
        "label": "Bahrain"
    },
    {
        "value": "BD",
        "label": "Bangladesh"
    },
    {
        "value": "BB",
        "label": "Barbados"
    },
    {
        "value": "BY",
        "label": "Belarus"
    },
    {
        "value": "BE",
        "label": "Belgium"
    },
    {
        "value": "BZ",
        "label": "Belize"
    },
    {
        "value": "BJ",
        "label": "Benin"
    },
    {
        "value": "BT",
        "label": "Bhutan"
    },
    {
        "value": "BO",
        "label": "Bolivia"
    },
    {
        "value": "BA",
        "label": "Bosnia & Herzegovina"
    },
    {
        "value": "BW",
        "label": "Botswana"
    },
    {
        "value": "BR",
        "label": "Brazil"
    },
    {
        "value": "BN",
        "label": "Brunei"
    },
    {
        "value": "BG",
        "label": "Bulgaria"
    },
    {
        "value": "BF",
        "label": "Burkina Faso"
    },
    {
        "value": "BI",
        "label": "Burundi"
    },
    {
        "value": "CL",
        "label": "Chile"
    },
    {
        "value": "CN",
        "label": "China"
    },
    {
        "value": "CR",
        "label": "Costa Rica"
    },
    {
        "value": "DK",
        "label": "Denmark"
    },
    {
        "value": "DM",
        "label": "Dominica"
    },
    {
        "value": "DO",
        "label": "Dominican Republic"
    },
    {
        "value": "DJ",
        "label": "Djibouti"
    },
    {
        "value": "EC",
        "label": "Ecuador"
    },
    {
        "value": "CI",
        "label": "Côte d’Ivoire"
    },
    {
        "value": "SV",
        "label": "El Salvador"
    },
    {
        "value": "ER",
        "label": "Eritrea"
    },
    {
        "value": "EE",
        "label": "Estonia"
    },
    {
        "value": "SZ",
        "label": "Eswatini"
    },
    {
        "value": "FJ",
        "label": "Fiji"
    },
    {
        "value": "FI",
        "label": "Finland"
    },
    {
        "value": "FR",
        "label": "France"
    },
    {
        "value": "GA",
        "label": "Gabon"
    },
    {
        "value": "GM",
        "label": "Gambia"
    },
    {
        "value": "GE",
        "label": "Georgia"
    },
    {
        "value": "GH",
        "label": "Ghana"
    },
    {
        "value": "GD",
        "label": "Grenada"
    },
    {
        "value": "GR",
        "label": "Greece"
    },
    {
        "value": "GT",
        "label": "Guatemala"
    },
    {
        "value": "GN",
        "label": "Guinea"
    },
    {
        "value": "GW",
        "label": "Guinea-Bissau"
    },
    {
        "value": "GY",
        "label": "Guyana"
    },
    {
        "value": "HT",
        "label": "Haiti"
    },
    {
        "value": "HN",
        "label": "Honduras"
    },
    {
        "value": "IN",
        "label": "India"
    },
    {
        "value": "ID",
        "label": "Indonesia"
    },
    {
        "value": "IQ",
        "label": "Iraq"
    },
    {
        "value": "IR",
        "label": "Iran"
    },
    {
        "value": "IE",
        "label": "Ireland"
    },
    {
        "value": "IS",
        "label": "Iceland"
    },
    {
        "value": "IL",
        "label": "Israel"
    },
    {
        "value": "IT",
        "label": "Italy"
    },
    {
        "value": "JM",
        "label": "Jamaica"
    },
    {
        "value": "JP",
        "label": "Japan"
    },
    {
        "value": "YE",
        "label": "Yemen"
    },
    {
        "value": "JO",
        "label": "Jordan"
    },
    {
        "value": "KH",
        "label": "Cambodia"
    },
    {
        "value": "CM",
        "label": "Cameroon"
    },
    {
        "value": "CA",
        "label": "Canada"
    },
    {
        "value": "CV",
        "label": "Cape Verde"
    },
    {
        "value": "KZ",
        "label": "Kazakhstan"
    },
    {
        "value": "QA",
        "label": "Qatar"
    },
    {
        "value": "KE",
        "label": "Kenya"
    },
    {
        "value": "KG",
        "label": "Kyrgyzstan"
    },
    {
        "value": "KI",
        "label": "Kiribati"
    },
    {
        "value": "CO",
        "label": "Colombia"
    },
    {
        "value": "KM",
        "label": "Comoros"
    },
    {
        "value": "CD",
        "label": "Congo - Kinshasa"
    },
    {
        "value": "CG",
        "label": "Congo - Brazzaville"
    },
    {
        "value": "KP",
        "label": "North Korea"
    },
    {
        "value": "KR",
        "label": "South Korea"
    },
    {
        "value": "HR",
        "label": "Croatia"
    },
    {
        "value": "CU",
        "label": "Cuba"
    },
    {
        "value": "KW",
        "label": "Kuwait"
    },
    {
        "value": "LA",
        "label": "Laos"
    },
    {
        "value": "LS",
        "label": "Lesotho"
    },
    {
        "value": "LV",
        "label": "Latvia"
    },
    {
        "value": "LB",
        "label": "Lebanon"
    },
    {
        "value": "LR",
        "label": "Liberia"
    },
    {
        "value": "LY",
        "label": "Libya"
    },
    {
        "value": "LI",
        "label": "Liechtenstein"
    },
    {
        "value": "LT",
        "label": "Lithuania"
    },
    {
        "value": "LU",
        "label": "Luxembourg"
    },
    {
        "value": "MG",
        "label": "Madagascar"
    },
    {
        "value": "MW",
        "label": "Malawi"
    },
    {
        "value": "MY",
        "label": "Malaysia"
    },
    {
        "value": "MV",
        "label": "Maldives"
    },
    {
        "value": "ML",
        "label": "Mali"
    },
    {
        "value": "MT",
        "label": "Malta"
    },
    {
        "value": "MA",
        "label": "Morocco"
    },
    {
        "value": "MH",
        "label": "Marshall Islands"
    },
    {
        "value": "MR",
        "label": "Mauritania"
    },
    {
        "value": "MU",
        "label": "Mauritius"
    },
    {
        "value": "MX",
        "label": "Mexico"
    },
    {
        "value": "FM",
        "label": "Micronesia"
    },
    {
        "value": "MD",
        "label": "Moldova"
    },
    {
        "value": "MC",
        "label": "Monaco"
    },
    {
        "value": "MN",
        "label": "Mongolia"
    },
    {
        "value": "ME",
        "label": "Montenegro"
    },
    {
        "value": "MZ",
        "label": "Mozambique"
    },
    {
        "value": "MM",
        "label": "Myanmar (Burma)"
    },
    {
        "value": "NA",
        "label": "Namibia"
    },
    {
        "value": "NR",
        "label": "Nauru"
    },
    {
        "value": "NP",
        "label": "Nepal"
    },
    {
        "value": "NZ",
        "label": "New Zealand"
    },
    {
        "value": "NI",
        "label": "Nicaragua"
    },
    {
        "value": "NL",
        "label": "Netherlands"
    },
    {
        "value": "NE",
        "label": "Niger"
    },
    {
        "value": "NG",
        "label": "Nigeria"
    },
    {
        "value": "MK",
        "label": "North Macedonia"
    },
    {
        "value": "NO",
        "label": "Norway"
    },
    {
        "value": "OM",
        "label": "Oman"
    },
    {
        "value": "TL",
        "label": "Timor-Leste"
    },
    {
        "value": "PK",
        "label": "Pakistan"
    },
    {
        "value": "PW",
        "label": "Palau"
    },
    {
        "value": "PA",
        "label": "Panama"
    },
    {
        "value": "PG",
        "label": "Papua New Guinea"
    },
    {
        "value": "PY",
        "label": "Paraguay"
    },
    {
        "value": "PE",
        "label": "Peru"
    },
    {
        "value": "PH",
        "label": "Philippines"
    },
    {
        "value": "PL",
        "label": "Poland"
    },
    {
        "value": "PT",
        "label": "Portugal"
    },
    {
        "value": "RW",
        "label": "Rwanda"
    },
    {
        "value": "RO",
        "label": "Romania"
    },
    {
        "value": "RU",
        "label": "Russia"
    },
    {
        "value": "SB",
        "label": "Solomon Islands"
    },
    {
        "value": "ZM",
        "label": "Zambia"
    },
    {
        "value": "WS",
        "label": "Samoa"
    },
    {
        "value": "SM",
        "label": "San Marino"
    },
    {
        "value": "ST",
        "label": "São Tomé & Príncipe"
    },
    {
        "value": "SA",
        "label": "Saudi Arabia"
    },
    {
        "value": "SE",
        "label": "Sweden"
    },
    {
        "value": "SN",
        "label": "Senegal"
    },
    {
        "value": "RS",
        "label": "Serbia"
    },
    {
        "value": "SC",
        "label": "Seychelles"
    },
    {
        "value": "SL",
        "label": "Sierra Leone"
    },
    {
        "value": "ZW",
        "label": "Zimbabwe"
    },
    {
        "value": "SG",
        "label": "Singapore"
    },
    {
        "value": "SK",
        "label": "Slovakia"
    },
    {
        "value": "SI",
        "label": "Slovenia"
    },
    {
        "value": "SO",
        "label": "Somalia"
    },
    {
        "value": "ES",
        "label": "Spain"
    },
    {
        "value": "LK",
        "label": "Sri Lanka"
    },
    {
        "value": "KN",
        "label": "St. Kitts & Nevis"
    },
    {
        "value": "LC",
        "label": "St. Lucia"
    },
    {
        "value": "VC",
        "label": "St. Vincent & Grenadines"
    },
    {
        "value": "ZA",
        "label": "South Africa"
    },
    {
        "value": "SD",
        "label": "Sudan"
    },
    {
        "value": "SS",
        "label": "South Sudan"
    },
    {
        "value": "SR",
        "label": "Suriname"
    },
    {
        "value": "SY",
        "label": "Syria"
    },
    {
        "value": "TJ",
        "label": "Tajikistan"
    },
    {
        "value": "TZ",
        "label": "Tanzania"
    },
    {
        "value": "TH",
        "label": "Thailand"
    },
    {
        "value": "TG",
        "label": "Togo"
    },
    {
        "value": "TO",
        "label": "Tonga"
    },
    {
        "value": "TT",
        "label": "Trinidad & Tobago"
    },
    {
        "value": "TD",
        "label": "Chad"
    },
    {
        "value": "CZ",
        "label": "Czechia"
    },
    {
        "value": "TN",
        "label": "Tunisia"
    },
    {
        "value": "TR",
        "label": "Turkey"
    },
    {
        "value": "TM",
        "label": "Turkmenistan"
    },
    {
        "value": "TV",
        "label": "Tuvalu"
    },
    {
        "value": "UG",
        "label": "Uganda"
    },
    {
        "value": "UA",
        "label": "Ukraine"
    },
    {
        "value": "HU",
        "label": "Hungary"
    },
    {
        "value": "UY",
        "label": "Uruguay"
    },
    {
        "value": "UZ",
        "label": "Uzbekistan"
    },
    {
        "value": "VU",
        "label": "Vanuatu"
    },
    {
        "value": "VE",
        "label": "Venezuela"
    },
    {
        "value": "AE",
        "label": "United Arab Emirates"
    },
    {
        "value": "US",
        "label": "United States"
    },
    {
        "value": "VN",
        "label": "Vietnam"
    },
    {
        "value": "CF",
        "label": "Central African Republic"
    },
    {
        "value": "CY",
        "label": "Cyprus"
    }
]

const COUNTRIES_TOP = [
    {
        "value": "DE",
        "label": "Germany"
    },
    {
        "value": "AT",
        "label": "Austria"
    },
    {
        "value": "CH",
        "label": "Switzerland"
    },
    {
        "value": "GB",
        "label": "United Kingdom"
    }
]

SimpleSelect.COUNTRY_OPTIONS = [
	{label: 'Common', options: COUNTRIES_TOP},
	{label: 'Other', options: COUNTRIES_ALL}
]
